module.exports = __webpack_public_path__ + "static/media/11.9ac73888.png";